"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BindingConstraintUtils = void 0;
class BindingConstraintUtils {
    static always = (_bindingConstraints) => {
        return true;
    };
}
exports.BindingConstraintUtils = BindingConstraintUtils;
//# sourceMappingURL=BindingConstraintUtils.js.map